"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Stances;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MainMenuModule = _interopRequireDefault(require("../../MainMenu.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Stances(_ref) {
  var className = _ref.className;
  var stances = {
    attackPeaceful: "ATTACK",
    runWalk: "RUN",
    sitStand: "SIT"
  };
  var attackPeaceful = stances.attackPeaceful,
      runWalk = stances.runWalk,
      sitStand = stances.sitStand;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.stances, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.small, _MainMenuModule.default.attackMode)
  }, attackPeaceful === "ATTACK" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.ATTACK_19X19
  }), attackPeaceful === "PEACEFULL" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PEACE_19X19
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.small, _MainMenuModule.default.walkRun)
  }, runWalk === "WALK" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.WALK_19X19
  }), runWalk === "RUN" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.RUN_19X19
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.small, _MainMenuModule.default.standSit)
  }, sitStand === "SIT" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SIT_19X19
  }), sitStand === "STAND" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.STAND_19X19
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.small, _MainMenuModule.default.view)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.VIEW_TRANS_19X19
  })));
}